import { render, staticRenderFns } from "./TpaBulkImportModal.vue?vue&type=template&id=fda8769c&scoped=true&"
import script from "./TpaBulkImportModal.vue?vue&type=script&lang=js&"
export * from "./TpaBulkImportModal.vue?vue&type=script&lang=js&"
import style0 from "./TpaBulkImportModal.vue?vue&type=style&index=0&id=fda8769c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda8769c",
  null
  
)

export default component.exports